module.exports = __webpack_public_path__ + "materialdesignicons-webfont.32562ea54b66a048a7d0.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/node_modules/mdi/fonts/materialdesignicons-webfont.woff2?v=2.2.43
// module id = ../../../../mdi/fonts/materialdesignicons-webfont.woff2?v=2.2.43
// module chunks = styles